import {ChangeDetectionStrategy, Component} from '@angular/core';
import {CopyTooltipModule} from '../../../../copy-tooltip/copy-tooltip.module';
import {WalletAvatarComponent} from '../../../../dex/wallet-avatar/wallet-avatar.component';
import {DropdownMenuComponent} from '../../../../dropdown-menu';
import {ScrollbarWithEndingBlindsModule} from '../../../../scrollbar-with-ending-blinds';
import {TooltipModule} from '../../../../tooltip';
import {L10nModule} from '../../../../translate';

@Component({
    selector:        'ul[dropdown-menu]',
    templateUrl:     './dyn-wallet-menu.component.html',
    styleUrls:       [
        '../../../../dropdown-menu/dropdown-menu.component.scss',
        './dyn-wallet-menu.component.scss'
    ],
    imports: [
        ScrollbarWithEndingBlindsModule,
        TooltipModule,
        L10nModule,
        WalletAvatarComponent,
        CopyTooltipModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynWalletMenuComponent extends DropdownMenuComponent {}
